import { JSX } from "react";

import { Outlet } from "react-router-dom";

function ShopDashboardPage(): JSX.Element {
  return <Outlet />;
}

export default ShopDashboardPage;
